__turbopack_context__.v({
  "loaderContainer": "ProspectSearch-module__s0DSyW__loaderContainer",
  "mainBody": "ProspectSearch-module__s0DSyW__mainBody",
  "selector": "ProspectSearch-module__s0DSyW__selector",
  "selectors": "ProspectSearch-module__s0DSyW__selectors",
});
